import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'sanitizer',
    standalone: true
})
export class SanitizerPipe implements PipeTransform {
    constructor(private readonly sanitizer: DomSanitizer) {}

    transform(html: string | null | undefined): SafeHtml {
        if (!html) {
            return this.sanitizer.bypassSecurityTrustHtml('');
        }

        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
